import { ALL_ITEM_URL, BASE_URL_INVENTORY, ITEM_DETAIL_BY_UUID, ITEM_URL } from '../../CONSTANTS';
import { callGetAxios, callPostAxios, callPutAxios } from '../common/common';

export const getActiveItemRecords = (data) => {
    return callPostAxios(ITEM_URL() + 'getAllActiveRecords/', data, 'getActiveItemRecords');
};

export const getKeyValueForBatches1 = () => {
    return callGetAxios(ITEM_URL() + 'getKeyValueForBatches/', 'getKeyValueForBatches1');
};

export const getIsIngredientItemList1 = () => {
    return callGetAxios(ITEM_URL() + 'getIsIngredientItemList/', 'getIsIngredientItemList1');
};

export const getNotIngredientItemList1 = () => {
    return callGetAxios(ITEM_URL() + 'getNotIngredientItemList/', 'getNotIngredientItemList');
};

export const activeDeactiveItem = (id) => {
    return callPutAxios(ITEM_URL() + 'activeOrDeActiveItem/' + id, id, 'activeDeactiveItem');
};

export const ItemListByWarePrice1 = (wId, pId, customerId, signal) => {
    let url = ITEM_URL() + 'getKeyValueDetailsList/' + wId + '/' + pId;
    if (customerId) {
        url += '/' + customerId;
    }
    return callGetAxios(url, 'ItemListByWarePrice1', signal);
};

export const uploadExcel = (data) => {
    return callPostAxios(ITEM_URL() + 'uploadItemsExcel', data, 'uploadExcel');
};

export const downloadItemExcel = (id) => {
    return callGetAxios(ITEM_URL() + 'downloadItemExcel/' + id, 'downloadItemExcel');
};

export const getItemList = (data) => {
    return callPostAxios(ALL_ITEM_URL(), data, 'getItemList');
};

export const getItemDetail = (id) => {
    return callGetAxios(ITEM_DETAIL_BY_UUID() + id, 'getItemDetail');
};
export const getItemHistoryLog = (id) => {
    return callGetAxios(ITEM_URL() + "getAllItemHistoryLog/" + id, 'getItemDetail');
};

export const getItemDetailKeyValuePair = () => {
    return callGetAxios(ITEM_URL() + 'getKeyValueDetailsList', 'getItemDetailKeyValuePair');
};

export const getItemKeyValueDetailsList = (uuid) => {
    return callGetAxios(ITEM_URL() + 'getKeyValueDetailsList/' + uuid, 'getItemKeyValueDetailsList');
};

export const addItem = (data) => {
    return callPostAxios(ITEM_URL(), data, 'addItem');
};

export const updateItem = (id, data) => {
    return callPostAxios(ITEM_URL() + id, data, 'updateItem');
};

export const keyValueItems = () => {
    return callGetAxios(ITEM_URL() + "getKeyValueItemsDetails")
}
export const submitFgItems = (data) => {
    return callPostAxios(BASE_URL_INVENTORY + "fgItems/save", data,)
}
export const GetFgItemsReports=(date)=>{
    return callPostAxios(BASE_URL_INVENTORY+"fgItems/"+"getTargetMonthReport?date="+date)
}
export const getSingleFgItem=(id)=>{
    return callPostAxios(BASE_URL_INVENTORY+"fgItems/"+"getTargetMonthReport/"+id)
}

